import { mapGetters } from 'vuex';
import * as i18n from '~/utils/i18n';
import 'vue-awesome/icons/check';

export default {
  props: {
    subMenuItems: {
      type: Array,
      default: () => [],
    },
    availableLanguages: {
      type: Array,
      default: () => [],
    },
    hideLogout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      language: 'en',
    };
  },
  computed: {
    ...mapGetters('auth', { userFullName: 'fullName' }),
    showLanguageSelector() {
      return this.availableLanguages && this.availableLanguages.length > 1;
    },
  },
  methods: {
    localeInNativeName(locale) {
      return i18n.translateInLocale(locale, 'locale_native_name');
    },
    logout() {
      this.$emit('logout');
    },
    localeSelect(locale) {
      this.language = locale;
      this.$emit('changeLanguage', locale);
    },
    getLanuageLink(code) {
      return `link_header_language_to_${code}`;
    },
  },
  mounted() {
    this.language = i18n.getLocale();
    i18n.eventBus.$on('language-changed', language => this.language = language);
  },
  beforeDestroy() {
    i18n.eventBus.$off('language-changed', language => this.language = language);
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/header/submenu/Submenu.js